$(".js-add-array-input-example a").on "click", (event) ->
  event.preventDefault()
  exampleInputCount = $(".array-input-example").length
  if exampleInputCount < 10
    $lastExampleField = $(".array-input-examples .include-remove-icon:last").clone()
    $lastExampleField.find("input").val("")
    $(".array-input-examples").append($lastExampleField)
    if exampleInputCount == 9
      $(".js-add-array-input-example").hide()

$(document).on "click", ".js-remove-array-input-example", (event) ->
  event.preventDefault()
  event.target.parentElement.remove()
  $(".js-add-array-input-example").show()




// WEBPACK FOOTER //
// ./app/javascript/lib/toolkit/behaviors/array_field.js.coffee